import {
    UI_START_LOADING,
    UI_STOP_LOADING,
    UI_SHOW_LOGIN_MODAL,
    UI_HIDE_LOGIN_MODAL,
} from './actionTypes';

export const startLoading = () => ({
    type: UI_START_LOADING,
});

export const stopLoading = () => ({
    type: UI_STOP_LOADING,
});

export const showLoginModal = () => ({
    type: UI_SHOW_LOGIN_MODAL,
});

export const hideLoginModal = () => ({
    type: UI_HIDE_LOGIN_MODAL,
});
